export interface ErrorWithStatus {
  networkStatus?: number;
  response?: {
    status: number;
  };
}

const parseStatusCode = (e: unknown): number => {
  if (typeof e === 'object' && e !== null) {
    const error = e as ErrorWithStatus;

    if (error.networkStatus) {
      return error.networkStatus;
    }
    if (error.response?.status) {
      return error.response.status;
    }
  }
  return 400;
};

export default parseStatusCode;
